// extracted by mini-css-extract-plugin
export default {"ringloader":"ringloader__cd7vN","ringload":"ringload__f9t9f","fullscreen":"fullscreen__eND7z"};